import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgCompleteVerification = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M11.965.509a1.046 1.046 0 0 1 1.232 0l2.601 1.896 3.22-.005c.39-.001.741.214.922.548l.075.176.988 3.062 2.61 1.89c.315.228.473.609.423.985l-.043.187-1 3.06 1 3.06c.121.37.025.77-.236 1.046l-.145.126-2.609 1.887-.988 3.064c-.12.37-.433.639-.806.707l-.191.018-3.22-.008-2.6 1.899c-.315.23-.726.262-1.069.098l-.164-.098-2.602-1.9-3.219.009c-.39 0-.741-.215-.921-.548l-.076-.177-.991-3.064L1.55 16.54a1.046 1.046 0 0 1-.424-.985l.043-.187 1-3.06-1-3.06a1.046 1.046 0 0 1 .236-1.046l.145-.126 2.606-1.89.991-3.062c.12-.37.433-.639.806-.707l.191-.017 3.22.005Zm.615 2.137-2.26 1.651c-.18.13-.396.201-.618.2l-2.8-.005-.859 2.664c-.051.159-.139.302-.256.418l-.126.108-2.268 1.64.87 2.66c.053.16.065.327.04.49l-.04.16-.87 2.66 2.268 1.642c.135.097.244.225.319.372l.063.153.859 2.662 2.8-.003c.166 0 .33.039.477.114l.141.086 2.26 1.65 2.262-1.65c.135-.098.29-.162.453-.188l.165-.012 2.797.003.862-2.662c.051-.158.14-.301.256-.418l.126-.107 2.266-1.642-.869-2.66a1.046 1.046 0 0 1-.038-.488l.038-.161.87-2.662-2.267-1.64a1.046 1.046 0 0 1-.319-.372l-.063-.153-.862-2.664-2.797.006c-.166 0-.33-.04-.477-.114l-.14-.087-2.263-1.651Zm5.122 6.184c.363.363.404.926.121 1.334l-.12.144-5.478 5.478a1.046 1.046 0 0 1-1.334.12l-.145-.12-2.738-2.739a1.046 1.046 0 0 1 1.334-1.6l.144.121 2 2 4.737-4.738a1.046 1.046 0 0 1 1.48 0Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgCompleteVerification)
const Memo = memo(ForwardRef)
export default Memo
